<template>
  <card-pane :cards-options="statsCards" :handle-click="handleClick"/>
</template>

<script>
import { markRaw } from 'vue'
import CardPane from '@/components/UIComponents/Custom/CardPane'
import LuminatiStatsCardTemplate from '@/components/Pages/Dashboard/common/LuminatiStatsCardTemplate'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    CardPane
  },
  data() {
    return {
      statsCards: [
        {
          logo: '/static/img/sms_aero_logo.png',
          title: 'Баланс SMS Aero',
          value: () => this.smsAeroBalance ? `${this.smsAeroBalance} ₽` : '-',
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateSmsAero',
          loading: true
        },
        {
          logo: '/static/img/brightdata_logo.png',
          title: 'Баланс Bright data',
          content: markRaw(LuminatiStatsCardTemplate),
          data: () => this.luminatiBalance || { balance: '-', currentMonth: null },
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateLuminati',
          loading: true
        },
        {
          logo: '/static/img/qiwi_logo.png',
          title: 'Баланс QIWI',
          value: () => this.qiwiBalance ? `${this.qiwiBalance} ₽` : '-',
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateQiwi',
          loading: true
        },
        {
          logo: '/static/img/capitalist_logo.png',
          title: 'Баланс Capitalist',
          value: () => this.capitalistBalance ? `${this.capitalistBalance.RUB} ₽` : '-',
          valueUSD: () => this.capitalistBalance ? `$ ${this.capitalistBalance.USD}` : '-',
          valueUSDT: () => this.capitalistBalance ? `${this.capitalistBalance.USDT} USDT` : '-',
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateCapitalist',
          loading: true
        },
        {
          logo: '/static/img/new-tel_logo.png',
          title: 'Баланс New-Tel',
          value: () => this.newtelBalance ? `${this.newtelBalance} ₽` : '-',
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateNewtel',
          loading: true
        },
        {
          logo: '/static/img/onlineSim_logo.png',
          title: 'Баланс OnlineSim',
          value: () => this.onlineSimBalance ? `${this.onlineSimBalance} ₽` : '-',
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateOnlineSim',
          loading: true
        },
        {
          logo: '/static/img/5sim_logo.svg',
          title: 'Баланс 5SIM',
          value: () => this.sim5Balance ? `${this.sim5Balance} ₽` : '-',
          footerText: 'Обновить',
          footerIcon: 'nc-icon nc-refresh-69',
          action: 'updateSim5',
          loading: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'smsAeroBalance',
      'luminatiBalance',
      'qiwiBalance',
      'capitalistBalance',
      'smscBalance',
      'ucallerBalance',
      'newtelBalance',
      'onlineSimBalance',
      'sim5Balance'
    ])
  },
  methods: {
    ...mapActions([
      'clearDashboardValues',
      'updateSmsAero',
      'updateSmsc',
      'updateLuminati',
      'updateQiwi',
      'updateCapitalist',
      'updateNewtel',
      'updateUcaller',
      'updateOnlineSim',
      'updateSim5'
    ]),
    async handleClick(action) {
      let index
      this.statsCards.map((item, idx) => {
        if (item.action === action) {
          index = idx
        }
      })
      if (index === undefined) return
      this.statsCards[index].loading = true
      await this[action]()
      this.statsCards[index].loading = false
    }
  },
  beforeMount() {
    this.updateSmsAero()
      .then(() => {
        this.statsCards[0].loading = false
      })
    this.updateLuminati()
      .then(() => {
        this.statsCards[1].loading = false
      })
    this.updateQiwi()
      .then(() => {
        this.statsCards[2].loading = false
      })
    this.updateCapitalist()
      .then(() => {
        this.statsCards[3].loading = false
      })
    this.updateNewtel()
      .then(() => {
        this.statsCards[4].loading = false
      })
    this.updateOnlineSim()
      .then(() => {
        this.statsCards[5].loading = false
      })
    this.updateSim5()
      .then(() => {
        this.statsCards[6].loading = false
      })
  },
  beforeUnmount() {
    this.clearDashboardValues()
  }
}
</script>

<style scoped>

</style>
